/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// assets/custom.js

(function () {
  async function syncHeaderCartCount() {
    try {
      const res = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;

      const cart = await res.json();

      // IMPORTANT: change this selector to match your theme’s badge element
      const badges = document.querySelectorAll('[data-cart-count]');

      badges.forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0; // remove if you don’t want it to hide
      });
    } catch (e) {
      // fail silently
    }
  }

  // Update when Palo Alto refreshes/rebuilds the cart
  document.addEventListener('theme:cart:refresh', syncHeaderCartCount);

  // Also update after the cart is rebuilt (your cart-element dispatches this)
  document.addEventListener('theme:cart:added', syncHeaderCartCount);

  // Optional: update on first page load
  document.addEventListener('DOMContentLoaded', syncHeaderCartCount);
})();

